// extracted by mini-css-extract-plugin
module.exports = {"lock":"LockButton_lock__TPMub","locked":"LockButton_locked___P2U4"};